export const isIOS = !!window.navigator.userAgent.match(/iPad/i) ||
  !!window.navigator.userAgent.match(/iPhone/i) ||
  !!window.navigator.userAgent.match(/Macintosh/i);
